import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { Language } from './languages.types';

const languagesApiPath = '/languages';

export const getLanguages = async (): Promise<AxiosResponse<Language[] & ApiError>> => {
  return instance.get<Language[]>(languagesApiPath).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createLanguage = async (data: Language): Promise<AxiosResponse<Language & ApiError>> => {
  return instance.post<Language>(languagesApiPath, data).catch(e => e.response as AxiosError<ApiError> as never);
};

export const getLanguage = async ({
  languageCode,
}: {
  languageCode: string;
}): Promise<AxiosResponse<Language & ApiError>> => {
  return instance.get<Language>(languageApiPath(languageCode)).catch(e => e.response as AxiosError<ApiError> as never);
};

const languageApiPath = (languageCode: string) => `/languages/${languageCode}`;

export const updateLanguage = async ({
  data,
  languageCode,
}: {
  languageCode: string;
  data: Partial<Language>;
}): Promise<AxiosResponse<Language & ApiError>> => {
  return instance
    .post<Language>(languageApiPath(languageCode), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteLanguage = async ({
  languageCode,
}: {
  languageCode: string;
}): Promise<AxiosResponse<Language & ApiError>> => {
  return instance
    .delete<Language>(languageApiPath(languageCode))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
